import {useSelector} from "react-redux";
import {getPlayers} from "../../../redux/playersSlice";
import Player from "../player/Player";
import BtnAdd from "./components/BtnAdd";
import T from "../../i18n/Text";
import {IPlayer, PlayerState} from "../../types";
import React, {useState} from "react";
import ModalAddPlayer from "./components/ModalAddPlayer";

export interface EmptyPlayer{
    id: null,
    name: null,
    avatarUrl: null
}
interface Props {
    onPlayersSelectionChange: (ids: string[]) => void;
    canSelectMore?: boolean;
    selectedPlayerIds: string[];
}

const GamePlayers = ({ onPlayersSelectionChange, canSelectMore = true, selectedPlayerIds }: Props) => {
    const updatePlayerState = ((player: IPlayer): IPlayer => {
        const state = selectedPlayerIds.includes(player.id) ? PlayerState.SELECTED : (canSelectMore ? PlayerState.DEFAULT : PlayerState.DISABLED);
        return {...player, state}
    });

    const players = useSelector(getPlayers).map(updatePlayerState);

    const [playerToBeUpdated, setPlayerToBeUpdated] = useState<IPlayer | null | EmptyPlayer>(null);

    const isModalOpen = playerToBeUpdated !== null;

    const onCancel = () => {
        setPlayerToBeUpdated(null);
    };

    const updatePlayer = (player: IPlayer) => {
        setPlayerToBeUpdated(player);
    };

    const onAdd = () => {
        setPlayerToBeUpdated(
            {
                id: null,
                name: null,
                avatarUrl: null
            })
    };

    const onPlayerSelectionChange = (id: string, selected: boolean) => {
        if (selected) onPlayersSelectionChange([...selectedPlayerIds, id]);
        else onPlayersSelectionChange(selectedPlayerIds.filter(pid => pid !== id))
    };

    return (
        <>
            <ul className="flex flex-wrap gap-x-[39px] gap-y-[29px] md:gap-x-[54px] md:gap-y-[35px] mx-auto mb-[36px] w-full place-content-center ">
                {players && players.map(player => {
                    return (
                        <li className="relative flex flex-col w-[70px] md:w-[157px]" key={player.id} >
                            <Player player={player} updatePlayer={updatePlayer} onPlayerSelectionChange={onPlayerSelectionChange} />
                        </li>
                    )
                })}
                <li className="flex flex-col justify-center items-center w-[70px] md:w-[157px]">
                    <BtnAdd onClick={onAdd}/>
                    <span className="text-[20px] leading-6 font-semibold text-black text-center"><T path='games.buttons.addPlayer'/></span>
                    <div className="invisible h-[37px]"/>
                </li>
            </ul>
            <ModalAddPlayer open={isModalOpen} onCancel={onCancel} playerToBeUpdated={playerToBeUpdated} />
        </>
    )
};

export default GamePlayers;
